import { Grid } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { Field } from "modules/app/components/ContactDetails/Details/styles";
import React from "react";

function CompanyTeamsRule({ teams, rule, errors, attributes, setAttributes }) {
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item style={{ textAlign: "right", width: "20%" }}>
        Equipes
      </Grid>

      <Grid item style={{ width: "50%" }}>
        <Autocomplete
          defaultValue={teams.filter((team) =>
            rule?.company_team_ids?.includes(team.id)
          )}
          style={{ marginTop: 20 }}
          options={teams}
          openOnFocus={true}
          multiple
          fullWidth
          renderInput={(params) => (
            <Field
              {...params}
              label="Equipes"
              variant="outlined"
              helperText={errors.usersOrCompanyTeam}
            />
          )}
          onChange={(_event, value) =>
            setAttributes({
              ...attributes,
              company_teams: value.map((v) => v.id),
            })
          }
          getOptionLabel={(field) => field.name}
          getOptionSelected={(option, value) => option.id === value.id}
        />
      </Grid>
    </Grid>
  );
}

export default CompanyTeamsRule;
